import { createFileRoute } from "@tanstack/react-router";
import ReviewOurWork from "@/pages/ReviewOurWork";

export const Route = createFileRoute("/review-our-work")({
  component: ReviewOurWork,
});
